import { useState, useEffect } from "react"

import { Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { usePlatforms } from "../contexts/PlatformsContext"

export default function NavTabs({ onPlatformChange, tabFor }) {
  const { getActivePlatforms, loading: platformsLoading } = usePlatforms();
  const [activeTab1, setactiveTab1] = useState("all")

  useEffect(() => {
    if (tabFor === "MetaOnly") {
      // Set to first active platform for MetaOnly mode
      const activePlatforms = getActivePlatforms()
      if (activePlatforms.length > 0) {
        setactiveTab1(activePlatforms[0].id)
      }
    }
  }, [tabFor, getActivePlatforms])

  function toggle1(tab) {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
      onPlatformChange(tab)
    }
  }
  
  return (
    <Nav pills style={{ marginLeft: 10 }}>
      <NavItem>
        {tabFor != "AppList" && tabFor !== "MetaOnly" ? (
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: activeTab1 === "all",
            })}
            onClick={() => {
              toggle1("all")
            }}
          >
            <span className="d-block d-sm-block">All</span>
          </NavLink>
        ) : (
          <></>
        )}
      </NavItem>
      
      {/* Dynamic platform tabs */}
      {!platformsLoading && getActivePlatforms().map((platform) => (
        <NavItem key={platform.id}>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: activeTab1 === platform.id,
            })}
            onClick={() => {
              toggle1(platform.id)
            }}
          >
            <span className="d-block d-sm-block">{platform.display_name}</span>
          </NavLink>
        </NavItem>
      ))}
      
      {platformsLoading && (
        <NavItem>
          <NavLink style={{ cursor: "default", color: "#999" }}>
            <span className="d-block d-sm-block">Loading...</span>
          </NavLink>
        </NavItem>
      )}
    </Nav>
  )
}
